import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsCodeModule } from 'se-fe-docs-code'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiHighlightLabelModule } from '../lib/shared-ui-highlight-label.module'
import { HighlightLabelDocsComponent } from './highlight-label-docs/highlight-label-docs.component'

@NgModule({
  imports: [
    CommonModule,
    SeFeCardModule,
    SeFeDocsCodeModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiHighlightLabelModule
  ],
  declarations: [HighlightLabelDocsComponent],
  exports: [HighlightLabelDocsComponent],
})
export class SharedUiHighlightLabelDocsModule {}
